












import Vue from "vue";
import Component from "vue-class-component";
import Page from "@/components/layout/page.vue";
import PageHeader from "@/components/navigation/page-header.vue";
import CustomersTable from "@/components/tables/customers-table.vue";

// See https://github.com/kaorun343/vue-property-decorator for all options

@Component({
    name: "customers",
    components: { Page, PageHeader, CustomersTable },
})
export default class Customers extends Vue {}
